import React, { useState } from "react";
import { Form, Select } from "antd";
import { useQuery } from "@apollo/client";
import { GET_EXHIBITIONS_CURSOR } from "graphql/query/exhibition-gql";
import Icons from "components/icons";
import { cursorPagination, Localize } from "components/service";
import { useDebounce } from "components/use-hooks";

interface IEmailChannelExhibitionTypeSelectProps {
  organizerID: string;
  excludedExhibitionTypeIDs?: string[];
  selectedExhibitionType?: {
    id: string;
    title: string;
  } | null;
}

const EmailChannelExhibitionTypeSelect: React.FC<
  IEmailChannelExhibitionTypeSelectProps
> = ({
  organizerID,
  excludedExhibitionTypeIDs = [],
  selectedExhibitionType,
}) => {
  const [searchText, setSearchText] = useState("");
  const { data, loading, fetchMore } = useQuery(GET_EXHIBITIONS_CURSOR, {
    skip: !organizerID,
    variables: {
      text: useDebounce(searchText),
      first: 50,
      where: {
        column: "ORGANIZER_ID",
        operator: "EQ",
        value: organizerID,
      },
      orderBy: [{ column: "ID", order: "DESC" }],
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  const { node, onPopupScroll } = cursorPagination({
    model: "exhibitionTypesCursor",
    data,
    loading,
    fetchMore,
  });
  const options = node
    .filter(
      ({ node: exhibitionType }) =>
        !excludedExhibitionTypeIDs.includes(exhibitionType.id)
    )
    .map(({ node: exhibitionType }) => ({
      value: exhibitionType.id,
      label: exhibitionType.title,
    }));

  return (
    <Form.Item
      name="exhibition_type_id"
      label={<Localize>EMAIL_CHANNEL.Form_Label_ExhibitionType</Localize>}
      rules={[
        {
          required: true,
          message: (
            <Localize>EMAIL_CHANNEL.Form_Required_ExhibitionType</Localize>
          ),
        },
      ]}
    >
      <Select
        showSearch
        suffixIcon={<Icons.Arrow />}
        filterOption={false}
        loading={loading}
        options={options}
        labelRender={({ label, value }) =>
          label ||
          (selectedExhibitionType?.id === String(value)
            ? selectedExhibitionType.title
            : value)
        }
        onSearch={setSearchText}
        onPopupScroll={onPopupScroll}
        placeholder={
          <Localize>EMAIL_CHANNEL.Form_Placeholder_ExhibitionType</Localize>
        }
      />
    </Form.Item>
  );
};

export default EmailChannelExhibitionTypeSelect;
